(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gg-home-runtime"] && !Shopify.designMode) return;
  try {
    function initHomeActionAlignment(root=document) {
 root.querySelectorAll('.gh-hero .gs-actions, .gh-farm .gs-actions, .gh-feature-actions, .gh-result-actions').forEach(actions => {
  if (actions.dataset.alignmentReady) return;
  actions.dataset.alignmentReady = 'true';
  const align = () => {
   const button = actions.querySelector('.gs-button'), label = button?.querySelector('.gh-action-label');
   if (!label || !actions.getClientRects().length) return;
   const links = [...actions.querySelectorAll(':scope > .gs-link')];
   links.forEach(link => { link.style.marginInlineStart = ''; link.style.maxWidth = ''; });
   const buttonRect = button.getBoundingClientRect(), labelRect = label.getBoundingClientRect();
   links.forEach(link => {
    const rect = link.getBoundingClientRect();
    if (rect.width && rect.top >= buttonRect.bottom - 1) {
     const inset = Math.max(0, labelRect.left - rect.left);
     link.style.marginInlineStart = inset + 'px';
     link.style.maxWidth = 'calc(100% - ' + inset + 'px)';
    }
   });
  };
  let width = -1;
  const observer = new ResizeObserver(entries => {
   const nextWidth = entries[0].contentRect.width;
   if (nextWidth !== width) { width = nextWidth; align(); }
  });
  observer.observe(actions);
  document.fonts.ready.then(align);
  actions.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
  align();
 });
}
initHomeActionAlignment();
document.addEventListener('shopify:section:load', event => initHomeActionAlignment(event.target));

if (!window.ggHomeHeroCartBound) {
 window.ggHomeHeroCartBound = true;
 document.addEventListener('submit', async event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.gh-hero .gh-buy, .gh-feature .gh-buy')) return;
  event.preventDefault();
  if (form.dataset.submitting === 'true') return;
  const button = form.querySelector('[type="submit"]'), status = form.querySelector('.gh-buy-status');
  if (!button || button.disabled || !status) return;
  const data = new FormData(form);
  data.delete('return_to');
  form.dataset.submitting = 'true';button.disabled = true;button.setAttribute('aria-busy','true');status.hidden = true;
  try {
   const response = await fetch(form.action.replace(/\/add(?:\?.*)?$/, '/add.js'), {method:'POST',body:data,headers:{Accept:'application/json'}});
   const result = await response.json();
   if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : status.dataset.error);
   status.textContent = status.dataset.success;status.hidden = false;
   document.dispatchEvent(new CustomEvent('cart:update',{detail:{resource:result,data:{source:'gg-home-hero'}}}));
  } catch(error) {
   status.textContent = error.message || status.dataset.error;status.hidden = false;
  } finally {
   delete form.dataset.submitting;button.disabled = false;button.removeAttribute('aria-busy');
  }
 });
}

function rankHomeBoxes(boxes, answers) {
 const selected = kind => answers.find(a => a.kind === kind)?.values || [];
 const species = selected('species'), broth = selected('cook').includes('broth');
 const priority = selected('priority');
 const weights = { life: 3, frequency: 1, cook: 6, shopping: 2, priority: 4 };
 return boxes.filter(box => box.species.length && box.species.every(s => species.includes(s)) && box.traits.includes('broth') === broth && (!priority.includes('lean') || box.traits.includes('lean')) && (!priority.includes('raw') || box.traits.includes('raw'))).map(box => {
  const matches = answers.filter(a => a.kind !== 'species' && a.kind !== 'interests' && a.values.some(v => box.traits.includes(v)));
  return {...box, matches, score: matches.reduce((sum,a) => sum + (weights[a.kind] || 0), 0)};
 }).sort((a,b) => Number(b.available)-Number(a.available) || b.score-a.score || a.order-b.order);
}
if (!customElements.get('gg-home-quiz')) customElements.define('gg-home-quiz', class extends HTMLElement {
 connectedCallback() {
  this.abort?.abort(); this.abort=new AbortController(); const signal=this.abort.signal;
  this.questions=[...this.querySelectorAll('[data-question]')]; this.cards=[...this.querySelectorAll('[data-box]')];
  if (!this.questions.length || !this.cards.length) return;
  this.index=0; this.querySelector('[data-quiz-fallback]').hidden=true; this.showQuestions();
  this.addEventListener('change',()=>this.paint(),{signal});
  this.querySelector('[data-next]').addEventListener('click',()=>{if(this.questions[this.index].dataset.kind!=='interests'&&!this.questions[this.index].querySelector('input:checked'))return;if(this.index<this.questions.length-1){this.index++;this.paint(true)}else this.result()},{signal});
  this.querySelector('[data-back]').addEventListener('click',()=>{this.index=Math.max(0,this.index-1);this.paint(true)},{signal});
  this.querySelector('[data-edit]').addEventListener('click',()=>{this.index=0;this.showQuestions();this.paint(true)},{signal});
  this.querySelector('[data-restart]').addEventListener('click',()=>{this.querySelectorAll('[data-question] input').forEach(i=>i.checked=false);this.index=0;this.showQuestions();this.paint(true)},{signal});
  this.closest('.shopify-section')?.addEventListener('shopify:block:select',e=>{const q=this.questions.findIndex(q=>q.contains(e.target)||q===e.target);if(q>=0){this.index=q;this.showQuestions()}},{signal});
 }
 disconnectedCallback(){this.abort?.abort()}
 showQuestions(){this.querySelector('[data-quiz-result]').hidden=true;this.querySelector('[data-quiz-questions]').hidden=false;this.paint()}
 paint(focus=false){this.questions.forEach((q,i)=>q.hidden=i!==this.index);this.querySelector('.gh-quiz-progress').textContent=`${this.dataset.stepLabel} ${this.index+1} ${this.dataset.ofLabel} ${this.questions.length}`;this.querySelector('[data-guide-meter]').style.width=`${(this.index+1)/this.questions.length*100}%`;const next=this.querySelector('[data-next]');next.disabled=this.questions[this.index].dataset.kind!=='interests'&&!this.questions[this.index].querySelector('input:checked');next.querySelector('[data-next-text]').textContent=this.index===this.questions.length-1?next.dataset.resultLabel:next.dataset.nextLabel;this.querySelector('[data-back]').disabled=this.index===0;if(focus)this.questions[this.index].querySelector('legend').focus({preventScroll:true})}
 result(){
  const answers=this.questions.map(q=>{const inputs=[...q.querySelectorAll('input:checked')];return {kind:q.dataset.kind,question:q.querySelector('legend').textContent,values:inputs.map(i=>i.value),labels:inputs.map(i=>i.closest('label').querySelector('span').textContent)}});
  if(answers.some(a=>a.kind!=='interests'&&!a.values.length))return;
  const interests=answers.filter(a=>a.kind==='interests').flatMap(a=>a.values);
  const tips=[...this.querySelectorAll('[data-interest-tip]')];
  tips.forEach(tip=>tip.hidden=!interests.includes(tip.dataset.interestTip));
  const tipsContainer=this.querySelector('[data-interest-tips]');
  if(tipsContainer)tipsContainer.hidden=!tips.some(tip=>!tip.hidden);
  const split=s=>(s||'').split(',').map(v=>v.trim()).filter(Boolean);
  const boxes=this.cards.map((card,order)=>({card,order,species:split(card.dataset.species),traits:split(card.dataset.traits),available:card.dataset.available==='true'}));
  const ranked=rankHomeBoxes(boxes,answers),available=ranked.filter(b=>b.available),shown=(available.length?available:ranked).slice(0,3);
  this.cards.forEach(c=>c.hidden=true);
  shown.forEach((box,index)=>{box.card.hidden=false;box.card.style.order=index});
  this.querySelector('[data-no-match]').hidden=ranked.length>0;this.querySelector('[data-unavailable]').hidden=!ranked.length||available.length>0;
  this.querySelector('[data-quiz-questions]').hidden=true;this.querySelector('[data-quiz-result]').hidden=false;this.querySelector('.gh-guide-result-title').focus({preventScroll:true});this.querySelector('.gh-guide-result-title').scrollIntoView({block:'start',behavior:'instant'});
 }
});
function initHomeVideos(root=document){root.querySelectorAll('.gh-video').forEach(wrapper=>{if(wrapper.dataset.ready)return;wrapper.dataset.ready='true';const video=wrapper.querySelector('video'),button=wrapper.querySelector('button'),slide=wrapper.closest('.gs-slide');let manualPause=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');const sync=()=>{const visible=!document.hidden&&!slide?.hidden&&slide?.getAttribute('aria-hidden')!=='true';if(visible&&!manualPause&&!reduced.matches)video.play().catch(()=>{});else video.pause()};video.addEventListener('play',()=>button.textContent=button.dataset.pauseLabel);video.addEventListener('play',()=>button.setAttribute('aria-label',button.dataset.pauseLabel));video.addEventListener('pause',()=>{button.textContent=button.dataset.playLabel;button.setAttribute('aria-label',button.dataset.playLabel)});button.addEventListener('click',()=>{if(video.paused){manualPause=false;video.play().catch(()=>{})}else{manualPause=true;video.pause()}});if(slide)new MutationObserver(sync).observe(slide,{attributes:true,attributeFilter:['hidden','aria-hidden']});document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);sync()})}
initHomeVideos();document.addEventListener('shopify:section:load',e=>initHomeVideos(e.target));

function paintHomeReviewStars(element,rating) {
 const value=Math.min(5,Math.max(0,Number(rating)||0));
 element.replaceChildren();
 for(let index=0;index<5;index++){
  const star=document.createElement('span'),empty=document.createElement('span'),fill=document.createElement('span');
  star.className='gh-rating-star';star.setAttribute('aria-hidden','true');empty.textContent=')';fill.textContent='(';fill.className='gh-rating-fill';
  fill.style.width=(Math.min(1,Math.max(0,value-index))*100)+'%';
  star.append(empty,fill);element.append(star);
 }
 element.setAttribute('aria-label',value.toLocaleString('sv-SE')+' av 5 stjärnor');
}
function relativeHomeReviewDate(date,now=Date.now()){
 const seconds=Math.max(0,Math.floor((now-date.getTime())/1000));
 const units=[['year',31536000],['month',2592000],['day',86400],['hour',3600],['minute',60],['second',1]];
 const [unit,size]=units.find(([,size])=>seconds>=size)||units[units.length-1];
 return new Intl.RelativeTimeFormat('sv-SE',{numeric:'always'}).format(-Math.floor(seconds/size),unit);
}

if(!customElements.get('gg-home-reviews'))customElements.define('gg-home-reviews',class extends HTMLElement{
 async connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal,status=this.querySelector('[role="status"]');const params=new URLSearchParams({reviews_selection:'store_reviews',carousel_type:'cards',star_rating:'all',max_reviews:'30',url:this.dataset.shopUrl,shop_domain:this.dataset.shop,platform:'shopify',primary_language:'sv',display_order:'most_recent'});try{const response=await fetch('https://cdn.judge.me/reviews/reviews_for_carousel?'+params,{signal});if(!response.ok)throw new Error('reviews');const data=await response.json();const reviews=(data.reviews||[]).filter(r=>Number(r.product_id)===0&&String(r.body||'').trim());if(!reviews.length){status.textContent=this.dataset.empty;return}const track=this.querySelector('.gh-review-track');track.replaceChildren();for(const review of reviews){const card=document.createElement('article');card.className='gh-review-card gs-recipe';const cardContent=document.createElement('div');cardContent.className='gs-recipe-image';card.append(cardContent);const stars=document.createElement('div');stars.className='gh-review-stars';const rating=Math.min(5,Math.max(0,Number(review.rating)||0));paintHomeReviewStars(stars,rating);stars.setAttribute('role','img');stars.setAttribute('aria-label',rating+' av 5 stjärnor');const name=document.createElement('h3');name.textContent=review.public_reviewer_name||review.reviewer_name||'Anonym';const time=document.createElement('time'),date=new Date(review.created_at);if(!Number.isNaN(date.getTime())){time.dateTime=date.toISOString();time.title=new Intl.DateTimeFormat('sv-SE',{day:'numeric',month:'long',year:'numeric'}).format(date);time.textContent=relativeHomeReviewDate(date)}const body=document.createElement('p');body.textContent=review.body;cardContent.append(stars,name,time,body);const more=document.createElement('button');more.type='button';more.hidden=true;more.className='gh-review-more';more.textContent=this.dataset.readMore;more.setAttribute('aria-expanded','false');body.id=track.id+'-body-'+track.children.length;more.setAttribute('aria-controls',body.id);more.addEventListener('click',()=>{const expanded=card.classList.toggle('is-expanded');more.setAttribute('aria-expanded',String(expanded));more.textContent=expanded?this.dataset.readLess:this.dataset.readMore;if(!expanded)this.updateReviewOverflow();},{signal});cardContent.append(more);track.append(card)}const total=Number(this.dataset.count),aggregate=Number(this.dataset.rating);const hasAggregate=total>0&&aggregate>0&&aggregate<=5;const average=hasAggregate?aggregate:reviews.reduce((s,r)=>s+Number(r.rating),0)/reviews.length;this.querySelector('[data-review-rating]').textContent=average.toLocaleString('sv-SE',{maximumFractionDigits:1,minimumFractionDigits:1})+'/5';this.querySelector('[data-review-count]').textContent=hasAggregate?total.toLocaleString('sv-SE')+' butiksomdömen':'Betyg för de '+reviews.length+' senaste butiksomdömena';paintHomeReviewStars(this.querySelector('.gh-review-score .gh-review-stars'),average);this.querySelector('.gh-review-layout').hidden=false;status.hidden=true;const oldCarousel=this.querySelector('.gh-review-carousel'),carousel=document.createElement('gg-season-recipes');carousel.className=oldCarousel.className;carousel.append(...oldCarousel.childNodes);oldCarousel.replaceWith(carousel);this.reviewResize?.disconnect();this.reviewResize=new ResizeObserver(()=>this.updateReviewOverflow());this.reviewResize.observe(track);this.updateReviewOverflow();document.fonts.ready.then(()=>{if(!signal.aborted)this.updateReviewOverflow()});}catch(error){if(error.name!=='AbortError')status.textContent=this.dataset.error}}
 updateReviewOverflow(){
  this.querySelectorAll('.gh-review-card').forEach(card=>{
   const button=card.querySelector('.gh-review-more'),body=card.querySelector('p');
   if(card.classList.contains('is-expanded')){button.hidden=false;return}
   button.hidden=true;
   if(body.getClientRects().length)button.hidden=body.scrollHeight<=body.clientHeight+1;
  });
 }
 disconnectedCallback(){this.abort?.abort();this.reviewResize?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gg-matvalet-styles"] && !Shopify.designMode) return;
  try {
    {
  let scheduled = false;
  const updateUppercaseTracking = () => {
    scheduled = false;
    document.querySelectorAll('.mv').forEach(root => {
      root.querySelectorAll('*').forEach(element => {
        if (element.closest('script, style, svg, noscript, .ggicon, .jdgm-widget')) return;
        const text = Array.from(element.childNodes)
          .filter(node => node.nodeType === Node.TEXT_NODE)
          .map(node => node.textContent).join('').trim();
        const hasLetters = text.toLocaleUpperCase('sv') !== text.toLocaleLowerCase('sv');
        const uppercase = hasLetters && (
          getComputedStyle(element).textTransform === 'uppercase' ||
          text === text.toLocaleUpperCase('sv')
        );
        element.toggleAttribute('data-mv-uppercase', uppercase);
      });
    });
  };
  const scheduleUppercaseTracking = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateUppercaseTracking);
  };
  const startUppercaseTracking = () => {
    if (!document.querySelector('.mv')) return;
    updateUppercaseTracking();
    const observer = new MutationObserver(scheduleUppercaseTracking);
    observer.observe(document.querySelector('main') || document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
    document.addEventListener('shopify:section:load', scheduleUppercaseTracking);
    window.addEventListener('resize', scheduleUppercaseTracking, { passive: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startUppercaseTracking, { once: true });
  } else {
    startUppercaseTracking();
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wld-brandon-line-height"] && !Shopify.designMode) return;
  try {
    (() => {
  const pending = new Set();
  let frame = 0;
  const inspect = root => {
    const nodes = [root, ...root.querySelectorAll('*')];
    for (const el of nodes) {
      if (!(el instanceof HTMLElement) || /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/.test(el.tagName)) continue;
      const hasText = [...el.childNodes].some(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim()) || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName);
      const family = hasText ? getComputedStyle(el).fontFamily.split(',')[0].replace(/["']/g, '').trim().toLowerCase() : '';
      const isBrandon = family === 'brandon text' || family === 'brandon-text' || family === 'brandon_text';
      if (el.hasAttribute('data-wld-brandon-line') !== isBrandon) el.toggleAttribute('data-wld-brandon-line', isBrandon);
    }
  };
  const queue = root => {
    if (!(root instanceof HTMLElement)) return;
    pending.add(root);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const roots = [...pending];
      pending.clear();
      for (const node of roots) if (node.isConnected && !roots.some(other => other !== node && other.contains(node))) inspect(node);
    });
  };
  const start = () => {
    inspect(document.body);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') queue(record.target);
        else if (record.type === 'characterData') queue(record.target.parentElement);
        else { for (const node of record.addedNodes) queue(node.nodeType === Node.TEXT_NODE ? node.parentElement : node); }
      }
    }).observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','style']});
    document.addEventListener('shopify:section:load', event => queue(event.target));
    window.addEventListener('resize', () => queue(document.body), {passive:true});
    document.fonts.ready.then(() => queue(document.body));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
